<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("newAssets.addNewAsset") }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`addNewContactsModal.close`)"
          ></button>
        </div>
        <div class="modal-body">
          <div class="text-start m-2 custom-input">
            <div class="row">
              <div class="col-12 mb-3 whitebg-input text-center" v-if="!asset.image_id">
                <label class="form-label bold-12 text-gray d-block"> {{ $t("newAssets.image") }} </label>
                <ImageUpload type="asset" :id="0" v-on:update="imageUploaded" />
              </div>
              <div class="col-12 mb-3 whitebg-input text-center" v-else>
                 <label class="form-label bold-12 text-gray d-block"> {{ $t("newAssets.image") }} </label>
                 <i class="fa fa-check text-success"></i>
              </div>
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> {{ $t("addNewContactsModal.name2") }} </label>
                <input class="form-control" v-model="asset.name" />
              </div>
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> {{ $t("newAssets.model") }} </label>
                <input class="form-control" v-model="asset.model" />
              </div>
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> {{ $t("newAssets.status") }} </label>
                <select class="form-select" v-model="asset.status">
                  <option :value="1">{{ $t("newAssets.active") }}</option>
                  <option :value="2">{{ $t("newAssets.archive") }}</option>
                  <option :value="3">{{ $t("newAssets.broken") }}</option>
                </select>
              </div>
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> {{ $t("newAssets.barcode") }} </label>
                <input class="form-control" v-model="asset.barcode" />
              </div>
              <div class="col-6 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> {{ $t("newAssets.value") }} </label>
                <input type="number" step="0.01" class="form-control" v-model="asset.value" />
              </div>
              <div class="col-6 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> {{ $t("newAssets.currency") }} </label>
                <select class="form-select" v-model="asset.currency_code">
                  <option v-for="currency in currencies" :key="currency.code" :value="currency.code">
                    {{ currency.code }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            v-on:click="addAsset"
            :class="{ 'loading-spin': loadAddBtn }"
            :disabled="loadAddBtn"
          >
            {{ $t("finance.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";
import ImageUpload from "../inputs/ImageUpload";
const bootstrap = require("bootstrap");

export default {
  name: "NewAssets",
  components: { ImageUpload },
  props: {
    modelValue: Object,
  },
  emits: ["update:modelValue", "add"],
  data() {
    return {
      myModal: undefined,
      success: false,
      loadAddBtn: false,
      asset: {
        status: 1
      },
    };
  },
  computed: {
    currencies() {
      return this.$store.state.currencies.filter((c) => c.enabled);
    },
  },
  methods: {
    imageUploaded(image) {
      this.asset.image_id = image.id;
    },
    showModal() {
      this.asset = {
        status: 1,
        currency_code: this.currencies[0]?.code,
      };
      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.myModal.show();
    },
    addAsset() {
      this.loadAddBtn = true;
      http
        .fetch("/assets", this.asset, true)
        .then((data) => {
          this.loadAddBtn = false;
          this.myModal.hide();
          this.$emit("add", data);
        })
        .catch(() => {
          this.loadAddBtn = false;
        });
    },
  },
};
</script>
